import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Plus } from "lucide-react";
import { api, formatApiErrorDetail } from "../../api";
import { DateInput, todayISO } from "../../DateInput";
import { CATEGORIES, Field } from "./shared";

const INPUT = "mt-1 w-full border border-slate-300 px-3 py-2 rounded-sm";

export function ItemForm({ reportId, onAdded }) {
  const [f, setF] = useState({
    item_date: todayISO(),
    category: "Passagem aérea",
    description: "",
    amount: "",
  });
  const [file, setFile] = useState(null);
  const [saving, setSaving] = useState(false);
  const set = (key) => (v) => setF((prev) => ({ ...prev, [key]: v }));

  const submit = async () => {
    if (!f.item_date || !f.category || !f.amount) {
      toast.error("Preencha data, categoria e valor.");
      return;
    }
    setSaving(true);
    try {
      const fd = new FormData();
      Object.entries(f).forEach(([k, v]) => fd.append(k, v));
      if (file) fd.append("receipt", file);
      const res = await api.post(`/portal/despesas/${reportId}/itens`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onAdded(res.data);
      setF((prev) => ({ ...prev, description: "", amount: "" }));
      setFile(null);
      toast.success("Item adicionado.");
    } catch (e) {
      toast.error(formatApiErrorDetail(e?.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="mt-4 border-t border-slate-200 pt-4" data-testid="expense-item-form">
      <div className="grid md:grid-cols-5 gap-3">
        <Field label="Data">
          <DateInput value={f.item_date} onChange={set("item_date")} testid="item-date" />
        </Field>
        <Field label="Categoria">
          <select
            value={f.category}
            onChange={(e) => set("category")(e.target.value)}
            className={`${INPUT} bg-white`}
            data-testid="item-category"
          >
            {CATEGORIES.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>
        </Field>
        <Field label="Descrição">
          <input value={f.description} onChange={(e) => set("description")(e.target.value)}
            className={INPUT} data-testid="item-description" />
        </Field>
        <Field label="Valor (R$)">
          <input type="number" step="0.01" value={f.amount}
            onChange={(e) => set("amount")(e.target.value)} className={INPUT} data-testid="item-amount" />
        </Field>
        <Field label="Comprovante (PDF/JPG/PNG)">
          <input
            type="file"
            accept=".pdf,.jpg,.jpeg,.png,.webp"
            onChange={(e) => setFile(e.target.files?.[0] || null)}
            className="mt-1 w-full text-xs"
            data-testid="item-receipt"
          />
        </Field>
      </div>
      <div className="mt-3 flex justify-end">
        <button
          data-testid="expense-item-add"
          onClick={submit}
          disabled={saving}
          className="inline-flex items-center gap-2 px-4 py-2 bg-slate-800 text-white text-[11px] uppercase tracking-[0.25em] hover:bg-black disabled:opacity-60"
        >
          {saving ? <Loader2 size={14} className="animate-spin" /> : <Plus size={14} />}
          Adicionar item
        </button>
      </div>
    </div>
  );
}
